import SocialButtons from './SocialButtons';

// The provider buttons on the website's server-rendered login page (Users::SessionsController#new).
export default function SignInButtons({ providers }) {
  return <SocialButtons providers={providers} onDone={(data) => { window.location.href = data.redirect || '/me'; }} />;
}
